import type { LineItem } from '@amigodoclt/core';

export const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
export const compact = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

export const money = (value: number) => currency.format(value);

/** Sinal colado ao valor, com o menos matemático (U+2212) que o design pede. */
export const plus = (value: number) => `+${currency.format(Math.abs(value))}`;
export const minus = (value: number) => `−${currency.format(Math.abs(value))}`;
export const withSign = (value: number) => (value < 0 ? minus(value) : plus(value));

/** As rubricas do core saem filtradas por amount > 0, então a busca precisa de fallback. */
export const amountOf = (lines: LineItem[] | undefined, label: string) =>
  lines?.find((line) => line.label === label)?.amount ?? 0;

export const sumOf = (lines: LineItem[] | undefined) =>
  lines?.reduce((total, line) => total + line.amount, 0) ?? 0;

/** 'monthsEarned' -> 'Months earned' para o resultado genérico. */
export const humanize = (key: string) => {
  const spaced = key.replace(/([A-Z])/g, ' $1').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

const rateKeys = ['rate', 'multiplier', 'percent', 'months'];
export const isRate = (key: string) => rateKeys.some((needle) => key.toLowerCase().includes(needle));
